import Api from '../services/Api'
// we now have an API object from the above

export default {
 
  getUnits(token) {
    const headerData = {
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json;version=1.3'
      }
    }
    const postData = {
      category_id: 0
    }
    return Api().post('unit/', postData, headerData)
  }
}
